export default __webpack_public_path__ + "static/media/htmlLogo.23784160.png";